import { ChevronRight } from 'lucide-react';

interface Props {
  broadcastedCount: number;
  acceptedCount: number;
  shortlistedCount: number;
  approvedTalentCount: number;
}

export default function CampaignPipelineChips({ broadcastedCount, acceptedCount, shortlistedCount, approvedTalentCount }: Props) {
  const steps = [
    { count: broadcastedCount, label: 'Broadcasted', color: 'bg-glass-3 text-glass-text-2 border border-glass' },
    { count: acceptedCount, label: 'Accepted', color: 'bg-emerald-500/15 text-emerald-500 dark:text-emerald-300 border border-emerald-500/30' },
    { count: shortlistedCount, label: 'Shortlisted', color: 'bg-accent2/15 text-accent2 border border-accent2/30' },
    { count: approvedTalentCount, label: 'In Production', color: 'bg-purple-500/15 text-purple-500 dark:text-purple-300 border border-purple-500/30' },
  ];
  const maxStep = steps.reduceRight((acc, step, i) => step.count > 0 && acc === -1 ? i : acc, -1);

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {steps.map((step, i) => (
        <div key={step.label} className="flex items-center gap-1">
          <span className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full font-medium ${i <= maxStep ? step.color : 'bg-glass-2 text-glass-text-3 border border-glass'}`}>
            <span className="font-bold">{step.count}</span> {step.label}
          </span>
          {i < steps.length - 1 && <ChevronRight className="w-3 h-3 text-glass-text-3" />}
        </div>
      ))}
    </div>
  );
}
